module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"emptyData":"No data"},"ru":{"emptyData":"Нет данных"}}')
  delete Component.options._Ctor
}
